import React from "react";
import "./css/Plans.css";
import { useUser } from "./UserContext";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
const API_URL = "https://api.hxabyte.com";

const plans = [
  {
    id: "trial",
    name: "Trial",
    price: "₹0",
    usd: "$0",
    features: ["Current basic tier", "Browse beats", "Limited site access"],
  },
  {
    id: "creator",
    name: "Creator",
    price: "₹49 / month",
    usd: "$0.5 / month",
    features: ["BeatMaker access", "Creator tools access"],
  },
  {
    id: "producer",
    name: "Producer",
    price: "₹299 / month",
    usd: "$3 / month",
    features: [
      "Full BeatMaker access",
      "All creator tools",
      "Priority creator features",
    ],
  },
];

function Plans() {
  const { user, userPlan, updateUserPlan } = useUser();
  const [loadingPlan, setLoadingPlan] = useState(null);
  const currentPlan = userPlan || "trial";
  const planLevel = {
    trial: 0,
    creator: 1,
    producer: 2,
  };
  const confirmToast = (message) => {
    return new Promise((resolve) => {
      toast(
        ({ closeToast }) => (
          <div>
            <p>{message}</p>
            <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
              <button
                onClick={() => {
                  resolve(true);
                  closeToast();
                }}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  resolve(false);
                  closeToast();
                }}
              >
                No
              </button>
            </div>
          </div>
        ),
        { autoClose: false, closeOnClick: false },
      );
    });
  };
  const cancelSubscription = async () => {
    if (!user) {
      toast.error("Please login first.");
      return;
    }

    const confirmed = await confirmToast(
      "Cancel your subscription? Your plan will move to Trial.",
    );

    if (!confirmed) return;

    try {
      setLoadingPlan("cancel");

      const res = await fetch(`${API_URL}/cancel-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.$id }),
      });

      const data = await res.json();

      if (!data.success) {
        toast.error(data.error || "Unable to cancel subscription.");
        return;
      }

      await updateUserPlan("trial");
      toast.success("Subscription cancelled.");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    } finally {
      setLoadingPlan(null);
    }
  };
  const isDowngradeOrSame = (targetPlan) => {
    return planLevel[targetPlan] <= planLevel[currentPlan];
  };
  const subscribe = async (planId) => {
    if (!user) {
      alert("Please login before changing plan.");
      return;
    }
    if (currentPlan === planId) return;

    if (isDowngradeOrSame(planId)) {
      const confirmed = await confirmToast(
        `Switch to ${
          planId === "trial"
            ? "Trial"
            : planId === "creator"
              ? "Creator"
              : "Producer"
        } plan? Downgrading will cancel your active subscription.`,
      );

      if (!confirmed) return;

      if (planId === "trial") {
        await cancelSubscription();
        return;
      }

      await updateUserPlan(planId);
      toast.success("Plan updated.");
      return;
    }

    try {
      setLoadingPlan(planId);
      const requestBody = {
        planId,
        userId: user.$id,
        firstname: user.name,
        email: user.email,
        phone: (user.phone || "9999999999")
          .replace(/\D/g, "")
          .replace(/^91/, ""),
      };

      console.log("========== SUBSCRIBE CLICK ==========");
      console.log("Selected Plan:", planId);
      console.log("Current Plan:", currentPlan);
      console.log("API URL:", `${API_URL}/create-subscription`);
      console.log("Request Body:", requestBody);
      console.log("User Object:", user);
      console.log("====================================");
      const res = await fetch(`${API_URL}/create-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await res.json();

      if (!data?.paymentUrl || !data?.params) {
        setLoadingPlan(null);
        alert(data?.error || "Unable to start subscription.");
        return;
      }

      const form = document.createElement("form");
      form.method = "POST";
      form.action = data.paymentUrl;

      Object.entries(data.params).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      console.error(err);
      setLoadingPlan(null);
      alert("Something went wrong");
    }
  };

  return (
    <div className="plans-page">
      <h1>Choose Your Plan</h1>
      <p className="plans-subtitle">
        Start free. Upgrade when you need more creator power.
      </p>

      <div className="plans-grid">
        {plans.map((plan) => (
          <div
            className={`plan-card ${
              currentPlan === plan.id
                ? "current-plan"
                : plan.id === "producer"
                  ? "popular"
                  : ""
            }`}
            key={plan.id}
          >
            <h2>{plan.name}</h2>
            <h3>{plan.price}</h3>
            <p>{plan.usd}</p>

            <ul>
              {plan.features.map((f) => (
                <li key={f}>✓ {f}</li>
              ))}
            </ul>

            <button
              disabled={currentPlan === plan.id || loadingPlan === plan.id}
              className={currentPlan === plan.id ? "current-plan-btn" : ""}
              onClick={() => subscribe(plan.id)}
            >
              {loadingPlan === plan.id ? (
                <>
                  <ClipLoader size={16} color="#fff" loading={true} />
                  <span style={{ marginLeft: "8px" }}>Processing...</span>
                </>
              ) : currentPlan === plan.id ? (
                "Current Plan"
              ) : isDowngradeOrSame(plan.id) ? (
                plan.id === "trial" ? (
                  "Switch to Trial"
                ) : (
                  `Switch to ${plan.name}`
                )
              ) : (
                "Subscribe"
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Plans;
